import api from './api';
import queryString from 'query-string';

const resource = 'GoogleBusiness/';

export const getStatus = async (companyId) => {
  return await api.get(resource + `status?companyId=${companyId}`);
};

export const disconnect = async (body) => {
  return await api.post(resource + 'disconnect', body);
};

export const getAccounts = async (companyId) => {
  return await api.get(resource + `accounts?companyId=${companyId}`);
};

export const getLocations = async (companyId) => {
  return await api.get(resource + `locations?companyId=${companyId}`);
};

export const selectLocation = async (body) => {
  return await api.post(resource + 'locations/select', body);
};

export const getWebsite = async (companyId) => {
  return await api.get(resource + `website?companyId=${companyId}`);
};

export const updateWebsite = async (body) => {
  return await api.post(resource + 'website/update', body);
};

export const rollbackWebsite = async (body) => {
  return await api.post(resource + 'website/rollback', body);
};

export const getReviews = async (companyId) => {
  return await api.get(resource + `reviews?companyId=${companyId}`);
};

export const draftReply = async (body) => {
  return await api.post(resource + 'reviews/draft-reply', body);
};

export const replyToReview = async (body) => {
  return await api.post(resource + 'reviews/reply', body);
};

/**
 * Builds the Google OAuth consent URL. The redirect_uri points at the backend
 * callback, which stores the tokens and redirects back to the dashboard.
 */
export const buildConnectUrl = (companyId) => {
  const params = {
    client_id: process.env.REACT_APP_GOOGLE_BUSINESS_CLIENT_ID,
    redirect_uri: process.env.REACT_APP_GOOGLE_BUSINESS_REDIRECT_URI,
    response_type: 'code',
    scope:
      process.env.REACT_APP_GOOGLE_BUSINESS_SCOPE ||
      'https://www.googleapis.com/auth/business.manage',
    access_type: 'offline',
    prompt: 'consent',
    include_granted_scopes: 'true',
    state: companyId,
  };
  return `https://accounts.google.com/o/oauth2/v2/auth?${queryString.stringify(
    params,
    { skipNull: true }
  )}`;
};

const googleBusinessApi = {
  getStatus,
  disconnect,
  getAccounts,
  getLocations,
  selectLocation,
  getWebsite,
  updateWebsite,
  rollbackWebsite,
  getReviews,
  draftReply,
  replyToReview,
  buildConnectUrl,
};

export default googleBusinessApi;
